import React, { FC } from 'react';

import { ROUTES } from '@common/constant/routeConstant';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import BreadCrumbs from 'src/components/atoms/breadcrumb';
import NextLink from 'src/components/atoms/link';

import { IBreadcrumb } from '@interfaces/app';

type BundleHeaderBannerBreadcrumbProps = {
  bundleName: string;
};

const BundleHeaderBannerBreadcrumb: FC<BundleHeaderBannerBreadcrumbProps> = ({ bundleName }) => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  const breadcrumbList: IBreadcrumb[] = [
    {
      description: t('course_detail.header_banner.breadcrumb.homepage'),
      url: '/',
    },
    {
      description: t('bundle_detail.header_banner.breadcrumb.bundle_list'),
      url: ROUTES.BUNDLE.LIST(),
    },
    {
      description: bundleName,
    },
  ];

  const breadcrumbs = breadcrumbList.map((item) => {
    if (!item.url) {
      return (
        <Typography
          key={`bundle-header-breadcrumb-${item.description}`}
          variant="BaseLegacy"
          color={theme.palette.textOnPrimary.secondary}
        >
          {item.description}
        </Typography>
      );
    }

    return (
      <NextLink key={`bundle-header-breadcrumb-${item.description}`} href={item.url}>
        <Button className="breadcrumb-link" variant="text" sx={{ color: '#FFF' }}>
          {item.description}
        </Button>
      </NextLink>
    );
  });

  return (
    <Box width="100%">
      <BreadCrumbs breadcrumbs={breadcrumbs} widthLastList="90%" color="#FFF" />
    </Box>
  );
};

export default BundleHeaderBannerBreadcrumb;
